"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'Information',
  data: function data() {
    var _this2 = this;
    var checkPhone = function checkPhone(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入客服电话'));
      } else {
        var regPone = null;
        var mobile = /^1(3|4|5|6|7|8|9)\d{9}$/; // 最新16手机正则
        var tel = /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/; // 座机
        if (value.charAt(0) == 0) {
          // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
          regPone = tel;
        } else {
          regPone = mobile;
        }
        if (!regPone.test(value)) {
          return callback(new Error("请填写客服电话(座机格式'区号-座机号码')"));
        }
        callback();
      }
    };
    var validateVal = function validateVal(rule, value, callback) {
      if (_this2.labelarr.length === 0) {
        callback(new Error('请输入后回车'));
      } else {
        callback();
      }
    };
    return {
      formConf: {
        fields: []
      },
      isCreate: 0,
      loginType: '1',
      headeNum: [{
        type: '1',
        name: '商户信息'
      }, {
        type: '2',
        name: '店铺信息'
      }, {
        type: '3',
        name: '结算信息'
      }],
      merData: {},
      // 默认数据
      submitLoading: false,
      // 提交loading
      editData: {},
      transferData: {},
      keyNum: 0,
      loading: false,
      merInfoForm: {
        qualification: '',
        avatar: '',
        backImage: '',
        streetBackImage: '',
        rectangleLogo: '',
        coverImage: '',
        intro: '',
        keywords: '',
        alertStock: 1,
        addressDetail: '',
        serviceType: '',
        serviceLink: null,
        servicePhone: '',
        latitude: '',
        //纬度
        longitude: '',
        //经度
        isTakeTheir: false,
        receiptPrintingSwitch: 0,
        // 小票打印开关：0关闭，1=自动打印，2=手动打印，3=自动和手动
        txMapKey: ''
      },
      rules: {
        intro: [{
          required: true,
          message: '请输入商户简介',
          trigger: 'blur'
        }],
        avatar: [{
          required: true,
          message: '请上传商户主头像',
          trigger: 'change'
        }],
        backImage: [{
          required: true,
          message: '请上传H5商户背景图',
          trigger: 'change'
        }],
        qualification: [{
          required: true,
          message: '请上传商户资质图',
          trigger: 'change'
        }],
        streetBackImage: [{
          required: true,
          message: '请上传H5商户街背景图',
          trigger: 'change'
        }],
        coverImage: [{
          required: true,
          message: '请上传商户封面图',
          trigger: 'change'
        }],
        rectangleLogo: [{
          required: true,
          message: '请上传商户logo（横）',
          trigger: 'change'
        }],
        labelarr: [{
          required: true,
          validator: validateVal,
          trigger: 'blur'
        }],
        alertStock: [{
          required: true,
          message: '请输入警戒库存',
          trigger: 'blur'
        }],
        serviceType: [{
          required: true,
          message: '请选择客服类型',
          trigger: 'change'
        }],
        serviceLink: [{
          required: true,
          message: '请输入H5链接',
          trigger: 'blur'
        }],
        servicePhone: [{
          required: true,
          validator: checkPhone,
          trigger: 'blur'
        }],
        addressDetail: [{
          required: true,
          message: '请选择商户地址',
          trigger: 'blur'
        }]
      },
      keyUrl: '',
      labelarr: [],
      serviceList: [{
        value: 'H5',
        label: 'H5链接'
      }, {
        value: 'phone',
        label: '电话'
      }],
      settlementForm: {
        settlementType: 'bank'
      },
      formId: '结算信息-银行卡'
    };
  },
  watch: {
    'settlementForm.settlementType': {
      handler: function handler(val) {
        switch (val) {
          case 'bank':
            this.formId = '结算信息-银行卡';
            break;
          case 'wechat':
            this.formId = '结算信息-微信';
            break;
          default:
            this.formId = '结算信息-支付宝';
            break;
        }
        this.keyNum += 1;
      },
      immediate: false,
      deep: true
    }
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['merchant:config:info'])) this.getConfigInfo();
    if ((0, _permission.checkPermi)(['merchant:settlement:info'])) this.getMerchantTransfer();
    if ((0, _permission.checkPermi)(['merchant:base:info'])) this.getInfo();
  },
  mounted: function mounted() {
    var that = this;
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;
      if (loc && loc.module === 'locationPicker') {
        // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        window.parent.selectAdderss(loc);
      } else {
        that.$message.warning('定位失败，稍后重试！');
      }
    }, false);
    window.selectAdderss = this.selectAdderss;
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, val) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        switch (val) {
          case 'avatar':
            _this.merInfoForm.avatar = img[0].sattDir;
            break;
          case 'backImage':
            _this.merInfoForm.backImage = img[0].sattDir;
            break;
          case 'rectangleLogo':
            _this.merInfoForm.rectangleLogo = img[0].sattDir;
            break;
          case 'coverImage':
            _this.merInfoForm.coverImage = img[0].sattDir;
            break;
          case 'qualification':
            _this.merInfoForm.qualification = img[0].sattDir;
            break;
          default:
            _this.merInfoForm.streetBackImage = img[0].sattDir;
            break;
        }
      }, tit, 'content');
    },
    // 选择经纬度
    selectAdderss: function selectAdderss(data) {
      this.merInfoForm.addressDetail = data.poiaddress + data.poiname;
      this.merInfoForm.latitude = data.latlng.lat;
      this.merInfoForm.longitude = data.latlng.lng;
    },
    changeSwitch: function changeSwitch() {
      var _this3 = this;
      var changeSwitch = this.merData.isSwitch ? '开启' : '关闭';
      this.$modalSure("".concat(changeSwitch, "\u8BE5\u5546\u6237\u5417")).then(function () {
        (0, _merchant.merchantSwitchApi)().then(function (res) {
          _this3.$modal.msgSuccess('修改成功');
        }).catch(function () {
          _this3.merData.isSwitch = !_this3.merData.isSwitch;
        });
      }).catch(function () {
        _this3.merData.isSwitch = !_this3.merData.isSwitch;
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this4.merInfoForm, '111111');
          _this4.merInfoForm.keywords = _this4.labelarr.join(',');
          (0, _merchant.merchantUpdateApi)(_this4.merInfoForm).then(function (res) {
            _this4.$message.success('操作成功');
            _this4.getConfigInfo();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }),
    transferhandlerSubmit: (0, _validate.Debounce)(function (formValue) {
      var _this5 = this;
      if ((0, _permission.checkPermi)(['merchant:settlement:info:edit'])) {
        (0, _merchant.merchantTransferEditApi)({
          id: this.formId,
          settlementType: this.settlementForm.settlementType,
          alipayCode: formValue.alipayCode,
          alipayQrcodeUrl: formValue.alipayQrcodeUrl,
          bankAddress: formValue.bankAddress,
          bankCard: formValue.bankCard,
          bankName: formValue.bankName,
          bankUserName: formValue.bankUserName,
          wechatCode: formValue.wechatCode,
          wechatQrcodeUrl: formValue.wechatQrcodeUrl,
          realName: formValue.realName
        }).then(function (res) {
          _this5.$message.success('操作成功');
          _this5.getMerchantTransfer();
        });
      } else {
        this.$message.warning('暂无操作权限');
      }
    }),
    // 获取商户信息
    getInfo: function getInfo() {
      var _this6 = this;
      this.loading = true;
      (0, _merchant.getBaseInfoApi)().then(function (res) {
        _this6.merData = res;
        localStorage.setItem('JavaMerchantBaseInfo', JSON.stringify(res));
        _this6.loading = false;
      }).catch(function () {
        _this6.loading = false;
      });
    },
    // 获取商户配置信息
    getConfigInfo: function getConfigInfo() {
      var _this7 = this;
      console.log(123465);
      (0, _merchant.merchantConfigInfoApi)().then(function (res) {
        _this7.merInfoForm = res;
        _this7.keyUrl = "https://apis.map.qq.com/tools/locpicker?type=1&key=".concat(_this7.merInfoForm.txMapKey, "&referer=myapp");
        localStorage.setItem('JavaMerchantConfigInfo', JSON.stringify(res));
        _this7.labelarr = res.keywords.split(',') || [];
      });
    },
    // 获取转账信息
    getMerchantTransfer: function getMerchantTransfer() {
      var _this8 = this;
      (0, _merchant.merchantTransferApi)().then(function (res) {
        _this8.transferData = res;
        _this8.settlementForm = res;
      });
    }
  }
};